import { KeyValueObj } from "@/common/types";

export const dashboardTableKeys = [
  "companyName",
  "tin",
  "category",
  "status",
  "dateSubmitted",
];

export const dashboardTableHeaders = [
  "Company Name",
  "TIN",
  "Category",
  "Status",
  "Date Submitted",
];

// ***** TableData example ********
export const dashboardTableData = [
  {
    id: "1",
    companyName: { type: "string", value: "Tech Innovations Ltd." },
    tin: { type: "string", value: "1234567890" },
    category: { type: "string", value: "IT Services" },
    status: {
      type: "string",
      value: "approved",
      jsx: (
        <div className="status-approved">
          <span className="status-dot approved" /> Approved
        </div>
      ),
    },
    dateSubmitted: { type: "string", value: "2025-06-01" },
  },
  // ...
];

interface ApiData {
  name: string;
  id: string;
  companyName: string | null;
  tin: string | null;
  category: string;
  status: string;
  date_submitted: string;
}

export const TableData = (Data: ApiData[]): KeyValueObj[] => {
  return Data?.map((datum) => ({
    id: datum?.id,

    companyName: {
      type: "string",
      value: datum?.name || "N/A",
    },
    tin: {
      type: "string",
      value: datum?.tin || "N/A",
    },
    category: {
      type: "string",
      value: datum?.category,
      style: { textTransform: "capitalize" },
    },
    status: {
      type: "status",
      value: datum?.status,
      statusType: datum?.status.toLowerCase(),
    },
    dateSubmitted: {
      type: "string",
      value: datum.date_submitted,
    },
  }));
};
